module.exports = __webpack_public_path__ + "static/media/unigranrio_logo_old.be983feb.png";